








































import { Vue, Component, Prop } from 'vue-property-decorator';

import CheckOutline from '~/components/icons/CheckOutline.vue';
import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import MarkdownContainer from '~/components/partials/MarkdownContainer.vue';

@Component({
  components: { ChevronRightSolid, CheckOutline, MarkdownContainer },
})
export default class DestinationRespectsCard extends Vue {
  @Prop(String) content: '';
}
